import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "../hooks/useAuth";
import { useRole } from "../hooks/useRole";
import type { EffectiveRole } from "./types";

type ProtectedRouteProps = {
  allow?: EffectiveRole[];
  children?: React.ReactNode;
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allow, children }) => {
  const { status } = useAuth();
  const { roles } = useRole();
  const location = useLocation();

  if (status === "signedOut") {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allow && !allow.some((role) => roles.includes(role))) {
    return <Navigate to="/no-access" replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default ProtectedRoute;
